import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config } from '../../shared';
import { EntityCreditAvailabilityModel } from '../../../../../../models/aggregates/erp/entity';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class EntityCreditAvailabilityService extends BaseApiTemplateService<EntityCreditAvailabilityModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/entity-credit-availability';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/entity-credit-availability';
    this.httpClient = http;
  }

  getEntityCreditAvailabilityByLoginEntity(visa: ApiVisa, entityGuid: string, companyGuid: string, docCcy: string): Observable<BasicApiResponseModel<EntityCreditAvailabilityModel>> {
    let url = this.apiUrl + '/login-entity-ep?entityGuid=' + entityGuid + '&companyGuid=' + companyGuid + '&docCcy=' + docCcy;

    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/login-entity-ep?entityGuid=' + entityGuid + '&companyGuid=' + companyGuid + '&docCcy=' + docCcy;
    }

    return this.httpClient.get<BasicApiResponseModel<any>>
      (url, this.getHttpHeader(visa));
  }

  getEntityCreditAvailabilityBackoffice(visa: ApiVisa, entityGuid: string, companyGuid: string, docCcy: string): Observable<BasicApiResponseModel<EntityCreditAvailabilityModel>> {
    let url = this.apiUrl + '/backoffice-ep?entityGuid=' + entityGuid + '&companyGuid=' + companyGuid + '&docCcy=' + docCcy;

    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/backoffice-ep?entityGuid=' + entityGuid + '&companyGuid=' + companyGuid + '&docCcy=' + docCcy;
    }

    return this.httpClient.get<BasicApiResponseModel<any>>
      (url, this.getHttpHeader(visa));
  }
}
